import { Link, useLoaderData, useParams } from "react-router-dom";
import * as API from "../services/conspostratamiento";

export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }
  return API.getConspostratamientoByID(params.consultapostratamientoId);
}

export function ConspostratamientoItem(props) {
  const conspostratamiento = useLoaderData();
  const errorMessage = conspostratamiento.message;

  const conspostResp = conspostratamiento.meta?.conspostResp;
  const metaFecha = conspostratamiento.meta?.metaFecha;
  const conspostMedio = conspostratamiento.meta?.conspostMedio;
  const conspostTipo = conspostratamiento.meta?.conspostTipo;
  const conspostObs = conspostratamiento.meta?.conspostObs;

  console.log(metaFecha);
  const conspostDate = new Date(conspostratamiento.date);
  const diffDate = Math.abs(new Date() - conspostDate) / 36e5;

  let { tratamientoId } = useParams();

  return (
    <>
      <div id='content'>
        {conspostratamiento.length === 0 ? (
          <div>Cargando...</div>
        ) : (
        errorMessage? (
          <p>{errorMessage}</p>
        ) : (
          <form id='formUpdatelement'>
            <fieldset id='disabledContainer' disabled='disabled'>
              <div className='grid--2col'>
                <div className='field'>
                  <label htmlFor='conspostResp'>Responsable</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='conspostResp'
                      required
                      type='text'
                      readOnly
                      value={conspostResp}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='metaFecha'>Fecha visita</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='metaFecha'
                      required
                      type='date'
                      readOnly
                      value={metaFecha}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='conspostMedio'>Medio</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='conspostMedio'
                        required
                        name='conspostMedio'
                        value={conspostMedio}
                      >
                        <option disabled readOnly value=''>
                          -- Selecciona una opción --
                        </option>
                        <option readOnly value='presencial'>
                          Presencial
                        </option>
                        <option readOnly value='videoconferencia'>
                          Videoconferencia
                        </option>
                        <option readOnly value='telefonico'>
                          Telefónico
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='conspostTipo'>Tipo</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='conspostTipo'
                        required
                        name='conspostTipo'
                        value={conspostTipo}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='medica'>Médica</option>
                        <option value='psicologica'>Psicológica</option>
                        <option value='psiquiatrica'>Psiquiátrica</option>
                        <option value='ypsilon'>Ypsilon ambulatorio</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div className='field'>
                <label htmlFor='conspostObs'>Observaciones</label>
                <div className='control'>
                  <textarea
                    className='textarea'
                    name='conspostObs'
                    id='conspostObs'
                    readOnly
                    value={conspostObs}
                  ></textarea>
                </div>
              </div>
            </fieldset>
          </form>
        ))}
      </div>
      {!errorMessage &&
      <div id='actions'>
      {((diffDate <= 72) && ((props.userRole.includes('psicologia-hospital') && conspostTipo === "psicologica") || (props.userRole.includes('psicologia') && conspostTipo === "psicologica") || (props.userRole.includes('medicina') && conspostTipo === "medica")) || (props.userRole.includes('administrador')))  && (
        <Link className='button is-link' to={`edit`}>
          Editar
        </Link>
      )}
      {(props.userRole.includes('administrador') || props.userRole.includes('psicologia-hospital') || props.userRole.includes('psicologia') || props.userRole.includes('medicina')) && (
      <Link className="button is-link" to={`../${tratamientoId}/seguimiento/consulta-post-tratamiento/new`}>Nuevo</Link>
      )}
      </div>
      }
    </>
  );
}
